import { useDispatch, useSelector } from "react-redux";
import { onTabChange, onPageChange } from "../../../redux/features/table/tableSlice";

const TableTabs = ({ tabs = [] }) => {
  const dispatch = useDispatch();
  const { tab } = useSelector((state) => state.table);

  return (
    <>
      <div className="tab-main">
        <div className="tabs">
          {tabs.map((t, index) => (
            <button className={`tab-btn ${tab?.value === t.value ? 'active' : ''}`}
              key={index}
              onClick={() => {
                dispatch(onTabChange({ key: t.paramKey, value: t.value }));
                dispatch(onPageChange({
                  pagenum: 0,
                  pagesize: 25,
                  recordstartindex: 0,
                  recordendindex: 25,
                }));
              }
              }
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default TableTabs;